// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"wc_a bht_b"};